module.exports = __webpack_public_path__ + "static/media/video_back.0c119e78.ogg";